import { isFirestorePermissionDeniedError } from "./firestoreAuthReady";

export function isBootstrapShellIncomplete(userData, classesData = []) {
  if (!userData || typeof userData !== "object") {
    return true;
  }

  if (userData.provisioningIncomplete === true) {
    return true;
  }

  if (!userData.settings || !Array.isArray(userData.orderOfClasses)) {
    return true;
  }

  const expectedClassCount = userData?.orderOfClasses?.length ?? 0;
  const loadedClassCount = classesData?.length ?? 0;

  return expectedClassCount > 0 && loadedClassCount === 0;
}

export function shouldContinueBootstrapShellRetry({
  attempt,
  standardRetryCount,
  lastReadError,
  lastShellIncomplete,
}) {
  return (
    attempt < standardRetryCount
    || lastShellIncomplete
    || isFirestorePermissionDeniedError(lastReadError)
  );
}

export function resolveBootstrapShellTerminalError({
  lastReadError,
  lastShellIncomplete,
}) {
  if (lastReadError) {
    return lastReadError;
  }
  if (lastShellIncomplete) {
    return new Error("Account setup is still finishing. Please try again.");
  }
  return null;
}
